<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Camps
              </p>
              <p class="product-subtitle">
                Empowering the youngest global citizens on Earth!
              </p>
              <p class="product-description">
                A unique learning exchange in Finland for preschoolers and their parents from around the world.
                Children follow lessons and activities at a local kindergarten.
                Parents visit iconic sites and unravel the Finnish heritage.
                Together take part in exciting evening activities, excursions and weekend escapes.
              </p>
              <p class="product-cta">
                <a href="javascript:;" @click="moreInfo = !moreInfo" class="button button-large button-secondary">{{moreInfo?'Read Less':'Read More'}}</a>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/camps.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-light section-description" v-if="moreInfo">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p class="subsection-title">
                Let’s go on a Fun Learning adventure together!
              </p>
              <p class="subsection-subtitle">
                Fun Learning camps is our initiative to enable families with young children to visit Finland,
                explore the local culture and experience innovative education practices in a meaningful and hassle free way.
              </p>
            </div>
          </div>

          <section-bullets :items="readMoreItems"></section-bullets>
        </div>
      </div>
    </section>

    <section class="hero section-services" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <strong>Camps</strong>
              </p>
            </div>
          </div>

          <div class="columns" v-for="(solution, index) in services" :key="index">
            <div class="column is-two-thirds" :class="{ 'is-offset-one-third': index % 2 !== 0 }">
              <service-card :data="solution" :isReverse="index % 2 !== 0" :onClick="loadResource"></service-card>
            </div>
          </div>

        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import SectionBullets from '@/components/SectionBullets'
import ServiceCard from '@/components/ServiceCard'
import Button from '@/components/Button'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    SectionBullets,
    ServiceCard,
    Button
  },

  created () {
    this.fetchCamps()
  },

  computed: {
    ...mapState('services', {
      services: state => state.camps,
      isLoading: state => state.isFetching
    })
  },

  methods: {
    ...mapActions('services', ['fetchCamps']),

    loadResource (id) {
      this.$router.push({ name: 'service', params: { id: id } })
    }
  },

  data () {
    return {
      moreInfo: false,
      readMoreItems: [
        `<strong>Local know how.</strong> Fun Academy is made in Finland. With us you will see and experience the best this country has to offer from nature havens to ingenious inventions.`,
        `<strong>Intercultural fluency.</strong> We celebrate diversity and respect you for who you are. The journey with us is a collaboration where we explore our values, traditions and customs together.`,
        `<strong>Kindergarten days.</strong> Give your little one the best start in life through a Fun Learning international exchange at a local kindergarten led by pedagogical wizards.`,
        `<strong>Fun Learning network.</strong> With us, you travel to Finland and unlock the world. We will connect you with our global community so you can share your Fun Learning moments and plan your next exchange together.`
      ],
      solutions: [
        {
          title: 'Educator Training',
          description: 'For early years educators & K-2 teachers of children aged 3 to 6. Provides continuous professional development in Fun Learning throughout the year. Supports bringing core life skills to the classroom to help children understand how the world works, identify their strengths and ignite a passion for lifelong learning.',
          img: '/static/img/assets/educator-training.png',
          to: { name: 'educator' }
        },
        {
          title: 'Trainer Training Program',
          description: 'For experienced early-years professionals interested in becoming Fun Academy Trainers! Combines the strong Finnish educators’ mindset with core life skills and present-day opportunities to take learning to the next level. Includes on-site training in Finland and continues throughout the year with online modules.',
          img: '/static/img/assets/trainer-training.png',
          to: { name: 'trainer' }
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.product-title{
  color: #0A2239;
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 1.125rem;
}

.product-subtitle{
  color: #363636;
  font-size: 1.25rem;
  line-height: 1.6;
}

.product-description{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 2rem;
}

.product-cta{
  margin-top: 1.5rem;
}

.character-correction{
  margin-bottom: -6rem;
}

.subsection-subtitle{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 1.6rem;
}

.section-testimonies{
  p{
    color: #6B7285;
    font-style: italic;
    font-size: 1.625rem;
    line-height: 1.55;
  }
  small{
    display: block;
    font-size: 1rem;
    padding-top: 1rem;
    i{
      color: #6B7285;
    }
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}

.product-image{
  width: 480px;
  height: 320px;
}

.section-services{
  .box{
    button{
      margin-right: 1rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/CampsPage.vue